import { baseApi } from "../redux/baseAPI";

export const ScreeningApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSmartForms: builder.query({
      query: (params = {}) => {
        let payLoad = {
          ...params,
          form_type:
            typeof params.type == "undefined" ? "not_pe_ros" : params.type,
        };
        return {
          url: `/form_builder/index_smart.json`,
          method: "GET",
          params: payLoad,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printPatientScreen: builder.mutation({
      query: (payload) => {
        return {
          url: `/patient_forms/print_patient_screening.json`,
          method: "POST",
          data: payload,
        };
      },
    }),
  }),
});

export const { useGetSmartFormsQuery, usePrintPatientScreenMutation } =
  ScreeningApi;
